import { CrossPaths } from 'components/about/CrossPaths';
import { GivingBack } from 'components/about/GivingBack';
import { NatureUnites } from 'components/about/NatureUnites';
import { OurCulture } from 'components/about/OurCulture';
import { OurValues } from 'components/about/OurValues';
import { HeroImage } from 'components/shared/HeroImage';
import { navScrollTo, NavItem, useScrollerNav } from 'components/shared/ScrollerNav';
import { AboutNavId } from 'components/about/types/AboutNavId';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import { wrapUrlSafe } from 'utils/language_support_util';
import { Context } from '@alltrails/shared/types/context';
import * as styles from './styles/styles.module.scss';
import ABOUT_PAGE_STRINGS from './about.strings';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';

type AboutContentProps = {
  context: Context;
};

const aboutHeroJpg = require('../../../assets/images/about/about-hero.jpg');
const aboutHeroAvif = require('../../../assets/images/about/about-hero.avif');
const aboutHeroWebp = require('../../../assets/images/about/about-hero.webp');
const aboutHeroMobileJpg = require('../../../assets/images/about/about-hero-750w.jpg');
const aboutHeroMobileAvif = require('../../../assets/images/about/about-hero-750w.avif');
const aboutHeroMobileWebp = require('../../../assets/images/about/about-hero-750w.webp');

const AboutContent = ({ context }: AboutContentProps): JSX.Element => {
  const languageRegionCode = useLanguageRegionCode();
  const {
    formattedDefaultMessages: {
      ABOUT,
      ABOUT_HERO_ALT,
      CONNECT_OUTDOORS,
      NAV_WHO_WE_ARE,
      NAV_OUR_CULTURE,
      NAV_OUR_VALUES,
      NAV_GIVING_BACK,
      SIGN_UP_FREE,
      UPGRADE_TO_PRO
    }
  } = useFormatMessage(ABOUT_PAGE_STRINGS);

  const sections: NavItem[] = [
    { id: AboutNavId.WhoWeAre, title: NAV_WHO_WE_ARE },
    { id: AboutNavId.OurValues, title: NAV_OUR_VALUES },
    { id: AboutNavId.OurCulture, title: NAV_OUR_CULTURE },
    { id: AboutNavId.GivingBack, title: NAV_GIVING_BACK }
  ];
  const { currentUser, proUser } = context;
  const ctaInfo = !!currentUser
    ? proUser
      ? null
      : { title: UPGRADE_TO_PRO, onClick: () => (window.location.href = wrapUrlSafe('/pro', languageRegionCode)) }
    : { title: SIGN_UP_FREE, onClick: () => (window.location.href = wrapUrlSafe('/signup', languageRegionCode)) };
  const { renderNavBar, renderSection } = useScrollerNav(ABOUT, sections, ctaInfo);

  return (
    <>
      <HeroImage
        backgroundImage={{
          jpg: { src: aboutHeroJpg, mobileSrc: aboutHeroMobileJpg },
          avif: { src: aboutHeroAvif, mobileSrc: aboutHeroMobileAvif },
          webp: { src: aboutHeroWebp, mobileSrc: aboutHeroMobileWebp },
          alt: ABOUT_HERO_ALT
        }}
        headerText={ABOUT}
        headerSubText={CONNECT_OUTDOORS}
        onArrowClick={() => navScrollTo(AboutNavId.WhoWeAre)}
        imgClassName={styles.heroImage}
      />
      {renderNavBar()}
      {renderSection(AboutNavId.WhoWeAre, <NatureUnites />)}
      {renderSection(AboutNavId.OurValues, <OurValues />)}
      {renderSection(AboutNavId.OurCulture, <OurCulture />)}
      {renderSection(AboutNavId.GivingBack, <GivingBack />)}
      <CrossPaths />
    </>
  );
};

export default AboutContent;
